import { Tag,Edit2, Link, Share2, Trash2 } from "react-feather";
import { Href } from "../../../Constant";
import { H3, LI, P, UL } from "../../../AbstractElements";
import { FavDesciptionDataProp } from "../../../Type/BookmarkTabType";

const FavDesciptionData = ({ myBookData}: FavDesciptionDataProp) => {
  const { title, website_url,collection,desc } = myBookData;
  return (
    <div className="desciption-data">
      <div className="title-bookmark">
        <H3 className="title_0">{title}</H3>
        <P className="weburl_0">{website_url}</P>
        <div className="hover-block">
          <UL className="simple-list flex-row">
            <LI><a href={Href}><Edit2 /></a></LI>
            <LI><a href={Href}><Link /></a></LI>
            <LI><a href={Href}><Share2 /></a></LI>
            <LI><a href={Href}><Trash2 /></a></LI>
            <LI className="text-end"><a href={Href}><Tag /></a></LI>
          </UL>
        </div>
        <div className="content-general">
          <P className="desc_0">{desc}</P>
          <span className="collection_0">{collection}</span>
        </div>
      </div>
    </div>
  );
};

export default FavDesciptionData;
